/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */


import React from 'react'
import { Column, Row } from '../../layout/components/dom'
import { useGlobal } from '../../utility/CTX'
import { Helmet } from 'react-helmet';

function Marketplace() {
  const { theme } = useGlobal();



  return <Column style={{flexGrow: 1, width: '100%', alignItems: 'center'}}>
    <Helmet>
      <title>Marketplace - Gateway Forge</title>
      <meta name="description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />
      <meta property="og:url" content="https://gatewayforge.com/marketplace" />
      <meta property="og:title" content="Marketplace - Gateway Forge" />
      <meta property="og:description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />

    </Helmet>

    
    <Row style={{margin: '10px auto', height: 100}}>
      
      <div>Promos</div>
      <div>Deals</div>
    </Row>
    <Row style={{maxWidth: 800, width: '90%', flexGrow: 1, borderRadius: 5, maxHeight: 100, minHeight: 100, background: theme.bg2, margin: '0px auto'}}>
      Featured Products
    </Row>
    <Row style={{margin: '10px auto', flexGrow: 1, maxWidth: 800, width: '90%'}}>
      <Column style={{background: theme.bg2, borderRadius: 5, padding: 5, width: 100, minHeight: 200}}>
        Filters
      </Column>
      <Column style={{background: theme.bg2, borderRadius: 5, padding: 5, flexGrow: 1, marginLeft: 10}}>
        Product List
      </Column>
    </Row>
  </Column>
}

export default Marketplace